import { post, get, put } from './api/http.service';

/**
 * Update firmware
 */
export const updateFirmware = (data) => {
  return post('/ccs/v1/camera/management/module/update', data);
};

/**
 * oneshotfocus
 */
export const oneshotfocus = (cameraId) => {
  return post(`/ccs/v1/camera/${cameraId}/setting/imaging/oneshotfocus`, {});
};

/**
 * Get camera record settings
 */
export const getCamRecordSettings = (cameraId, params) => {
  return get(`/ccs/v1/camera/${cameraId}/setting/recording`, params);
};

/**
 * Get camera record settings
 */
export const getCamImageSettings = (cameraId, params) => {
  return get(`/ccs/v1/camera/${cameraId}/setting/imaging`, params);
};

/**
 * Update video record setting
 */
export const updateRecordingVideoSetting = (cameraId, payload) => {
  return put(`/ccs/v1/camera/${cameraId}/setting/recording/video`, payload);
};

/**
 * Update setting camera name
 */
export const updateSettingCameraName = (payload) => {
  return put(`/ccs/v1/camera/name`, payload);
};

/**
 * Update audio record setting
 */
export const updateRecordingAudioSetting = (cameraId, payload) => {
  return put(`/ccs/v1/camera/${cameraId}/setting/recording/audio`, payload);
};

/**
 * Update wdr setting
 */
export const updateWdrSetting = (cameraId, payload) => {
  return put(`/ccs/v1/camera/${cameraId}/setting/imaging/wdr`, payload);
};

/**
 * Update display time setting
 */
export const updateDisplaytimeSetting = (cameraId, payload) => {
  console.log(cameraId, payload);
  return put(`/ccs/v1/camera/${cameraId}/setting/imaging/displaytime`, payload);
};

/**
 * Update daynight setting
 */
export const updateDaynightSetting = (cameraId, payload) => {
  return put(`/ccs/v1/camera/${cameraId}/setting/imaging/daynight`, payload);
};

/**
 * Reboot camera
 */
export const rebootCam = (cameraId, payload) => {
  return post(`/ccs/v1/camera/${cameraId}/setting/reboot`, payload);
};

/**
 * Fetch camera motion detection by ID
 */
export const getCameraMotion = (cameraId, params) => {
  return get(`/ccs/v1/camera/${cameraId}/setting/motionDetection`, params);
};

/**
 * Disable camera motion detection by ID
 */
export const disableCameraMotion = (cameraId) => {
  return put(`/ccs/v1/camera/${cameraId}/setting/motionDetection`, {
    value: { enable: 0 },
  });
};

/**
 * Save camera motion detection by ID
 */
export const saveCameraMotion = (cameraId, payload) => {
  return put(`/ccs/v1/camera/${cameraId}/setting/motionDetection`, payload);
};

/**
 * Update power frequency
 */
export const updatePowerFrequency = (cameraId, payload) => {
  return put(
    `/ccs/v1/camera/${cameraId}/setting/imaging/powerFrequency`,
    payload
  );
};
